import React from 'react';
import { Text, View, Pressable, Animated } from 'react-native';
import { useTheme } from '@themeProvider';
import { useLanguage } from '@languageProvider';
import { Commons, Spacing, Typography, Mixins, Colors, Icon } from '@styles';
import { useModal } from '@lib';
import { AddDelivery } from '@modals';
import { Button } from '@atoms';


export const PromotionWidget = ({ promotionsToShow, ...props }) => {
    const { translate } = useLanguage();
    const { useColor } = useTheme();
    const [ title, secondary ] = useColor(['title', 'secondary']);

    return (<Pressable {...props}>
        { promotionsToShow.length > 0 ?
            <View style={[{ backgroundColor: Colors.setOpacity(secondary, .05), padding: Spacing.XS }]}>
                <Text style={[Typography.SUBTITLE, { color: secondary, textAlign: 'center' }]}>{translate('applyingPromotions')}: <Text style={Typography.TITLE}>{promotionsToShow[0].coupon.name} </Text>{promotionsToShow.length > 1 ? translate('andNMore', {n: promotionsToShow.length - 1}) : ''}</Text>
            </View>
            : <Text style={[Typography.TITLE, { color: secondary, textAlign: 'center', padding: Spacing.XS }]}><Icon name="discount" size={Typography.TITLE.lineHeight} /> {translate('addDiscount')}</Text>
        }
    </Pressable>)
}
